const contextMethods: Record<string, Record<string, () => unknown>> = {};

export default contextMethods;
